import type FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import type FolderTreeData from '../store/schema/FolderTreeData';
import type { MailFolder } from 'owa-graph-schema';
import getMailboxFolderTreeDataTable from '../selectors/getMailboxFolderTreeDataTable';
import { mutatorAction } from 'satcheljs';
/**
 *
 * @param id folder id
 * @param rootFolder rootFolder for this folder tree
 * @param loadingState the loading state of this folder tree
 * @param hasMoreData indicates if the folder hierarchy has more folders on server
 * @param currentLoadedIndex index of the last folder in the hierarchy on client
 * @param userIdentity identifies the account uniquely
 */
export const setFolderTreeData = mutatorAction(
    'setFolderTreeData',
    (
        id: string,
        rootFolder: MailFolder,
        loadingState: FolderTreeLoadStateEnum,
        hasMoreData: boolean = false,
        currentLoadedIndex: number = 0,
        userIdentity: string
    ) => {
        const table = getMailboxFolderTreeDataTable(userIdentity);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (29,15): Type 'FolderTreeData | undefined' is not assignable to type 'FolderTreeData'.
        // @ts-expect-error
        const folderTreeData: FolderTreeData = table.get(id);
        if (folderTreeData) {
            folderTreeData.id = id;
            folderTreeData.rootFolder = rootFolder;
            folderTreeData.loadingState = loadingState;
            folderTreeData.hasMoreData = hasMoreData;
            folderTreeData.currentLoadedIndex = currentLoadedIndex;
        } else {
            table.set(id, {
                id: id,
                rootFolder: rootFolder,
                loadingState: loadingState,
                hasMoreData: hasMoreData,
                currentLoadedIndex: currentLoadedIndex,
            });
        }
    }
);
